import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCrest = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "black",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 0.799805L4.7998 4L8 7.2002L7.2002 8L4 4.7998L0.800781 8L0.000976562 7.2002L3.2002 4L0 0.799805L0.799805 0L4 3.2002L7.2002 0L8 0.799805Z" })
});
export default SvgCrest;
